<template>
  <el-dialog
      :visible.sync="copyTextDialog"
      :append-to-body="true"
      :before-close="cleanData">
    <div>
      <el-alert
          v-if="!copiedText"
          type="warning">
        Click in the input to copy
      </el-alert>
      <el-alert
          v-else
          type="success">
        Text copied!
      </el-alert>
      <br>
      <div v-if="enableInput">
        <el-input
            v-model="copyContentData"
            type="textarea"
            :rows="15"
            :readonly="true"
            @focus="selectAndCopy" />
      </div>
      <div v-else>
        Loading information...
      </div>
    </div>
    <span
        slot="footer"
        class="dialog-footer">
      <el-button @click="copyTextDialog = false">Close</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { forEach, get } from "lodash";
import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: accountGetters } = h("db/account");

export default {
  name: "CopyRequestModal",
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      copyTextDialog: false,
      copyContentData: "",
      copiedText: false,
      enableInput: false,
    };
  },
  computed: {
    ...accountGetters(["customer"]),
  },
  methods: {
    async openModal() {
      this.copyTextDialog = true;
      this.enableInput = true;
      this.parseData();
    },
    selectAndCopy(event) {
      event.target.select();
      try {
        const successful = document.execCommand("copy");
        this.copiedText = Boolean(successful);
      } catch (err) {
        this.copiedText = false;
      }
    },
    cleanData(done) {
      this.copiedText = false;
      done();
    },
    parseData() {
      let new_product = this.request.product || {
        description: this.request.new_product,
      };
      let reqName = this.request.type.split("::");
      let requestType = reqName[reqName.length - 1];
      let reasons =
        get(this.request, "request_reasons", null) ||
        get(this.request, "reasons", null) ||
        [];

      let parsed_reasons = reasons
        .map((rr) => rr.reason.text || rr.reason)
        .join(", ");
      console.log(this.request);
      this.copyContentData = [
        `Desired Product: ${new_product.description || ""}`,
        `Desired Color: ${get(this.request, "new_device_color", null) || ""} `,
        `Full Name: ${get(this.request, "customer_name", null) || ""} `,
        `Email: ${get(this.request, "customer_email", null) || ""} `,
        `Street Address: ${
          get(this.request, "customer_address_1", null) ||
          get(this.request, "shipping_address.address_1", null) ||
          ""
        }`,
        `Street Address 2: ${
          get(this.request, "customer_address_2", null) ||
          get(this.request, "shipping_address.address_2", null) ||
          ""
        }`,
        `City: ${
          get(this.request, "customer_city", null) ||
          get(this.request, "shipping_address.city", null) ||
          ""
        }`,
        `State: ${
          get(this.request, "customer_state", null) ||
          get(this.request, "shipping_address.state", null) ||
          ""
        }`,
        `Zip/Postal: ${
          get(this.request, "customer_zip", null) ||
          get(this.request, "shipping_address.zip", null) ||
          ""
        }`,
        `Country: ${
          get(this.request, "customer_country", null) ||
          get(this.request, "shipping_address.country", null) ||
          ""
        }`,
        `Phone #: ${
          get(this.request, "customer_phone", null) ||
          get(this.request, "shipping_address.phone", null) ||
          ""
        }`,
        `MAC ID: ${get(this.request, "old_device_id", null)}`,
        `Reason: ${parsed_reasons || ""}`,
        `Place of Purchase: ${get(this.request, "purchase_location", "")}`,
        `Date of initial Setup:`,
        `Order Number (If purchased from ring.com): ${
          get(this.request, "order_number", null) || ""
        }`,
        `PLC Request ID: ${get(this.request, "uuid", null) || ""}`,
        `PLC Request Type: ${requestType || ""}`,
      ].join("\n");
    },
  },
};
</script>
